import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { appConfig } from '@ami/react/core';
import { formatPrice } from '../../priceFormatter';
import ReviewQuoteProductQuantityModal from './ReviewQuoteProductQuantityModal';
import { isAmiUserGlobalAdministrator } from '../../../authorization/amiPermissions';

export default class ReviewQuoteCustomLineItemPricing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showQuantityModal: false,
    };
  }

  static propTypes = {
    pricing: PropTypes.object.isRequired,
    selectedPriceMode: PropTypes.string.isRequired,
    isoCurrencySymbol: PropTypes.string.isRequired,
    quoteCustomLineItem: PropTypes.object.isRequired,
    msrpClassNames: PropTypes.string.isRequired,
    dNetClassNames: PropTypes.string.isRequired,
    onQuantityUpdated: PropTypes.func,
    onAddOverrideDiscount: PropTypes.func,
    onEditOverrideDiscount: PropTypes.func,
    onRemoveOverrideDiscount: PropTypes.func
  };

  hideQuantityModal = () =>
    this.setState({ showQuantityModal: false });

  render() {
    const {
      pricing,
      selectedPriceMode,
      msrpClassNames,
      dNetClassNames,
      isoCurrencySymbol,
      quoteCustomLineItem,
      onQuantityUpdated,
      onAddOverrideDiscount,
      onEditOverrideDiscount,
      onRemoveOverrideDiscount
    } = this.props;

    const {
      baseComponent,
      subComponents,
      nonBaseComponents,
    } = pricing;

    const { showQuantityModal } = this.state;

    const considerDNetPrices = selectedPriceMode === "both" || selectedPriceMode === "dNetOnly";
    const anyPricingSubItems = considerDNetPrices
      ? (subComponents.some((x) => x.dNetPrice !== 0) || nonBaseComponents.some((x) => x.dNetPrice !== 0))
      : (subComponents.some((x) => x.msrp !== 0) || nonBaseComponents.some((x) => x.msrp !== 0));

    return (
      <div>
        <div className="row price-heading-mobile">
          <div className="col-6"></div>
          <div className={classNames('price-heading', msrpClassNames)}>
            MSRP
          </div>
          <div className={classNames('price-heading', dNetClassNames)}>
            D. NET
          </div>
        </div>
        {anyPricingSubItems && (
          <div className="row">
            <div className="col-6">Base price</div>
            <div className={msrpClassNames}>
              {formatPrice(baseComponent.msrp)}
            </div>
            <div className={dNetClassNames}>
              {formatPrice(baseComponent.dNetPrice)}
            </div>
          </div>
        )}
        {subComponents
          .filter((x) => considerDNetPrices ? x.dNetPrice !== 0 : x.msrp !== 0)
          .map((item, idx) => {
            return (
              <div className="row" key={idx}>
                <div className="col-6" style={{ paddingLeft: 25 }}>
                  {item.name}
                </div>
                <div className={msrpClassNames}>{formatPrice(item.msrp)}</div>
                <div className={dNetClassNames}>
                  {formatPrice(item.dNetPrice)}
                </div>
              </div>
            );
          })}
        {nonBaseComponents
          .filter((x) => considerDNetPrices ? x.dNetPrice !== 0 : x.msrp !== 0)
          .map((item, idx) => {
            return (
              <div className="row" key={idx}>
                <div className="col-6">
                  {item.name}
                  {isAmiUserGlobalAdministrator() && appConfig.isManagementApp && item.type === "Discount" && item.correlationId === "user-defined-discount" && (
                    <span className="ms-2">
                      {onEditOverrideDiscount &&
                        <button type="button" className="btn btn-link p-0" onClick={() => onEditOverrideDiscount(quoteCustomLineItem.id, quoteCustomLineItem.userDefinedDiscount)}>
                          <i className="fa fa-pencil-square-o" />
                        </button>
                      }
                      {onRemoveOverrideDiscount &&
                        <button
                          type="button"
                          className="btn btn-link text-danger p-0 ms-2"
                          onClick={() => onRemoveOverrideDiscount(quoteCustomLineItem.id)}
                        >
                          <i className="fa fa-trash" style={{ color: 'red' }} />
                        </button>
                      }
                    </span>
                  )}
                </div>
                <div className={msrpClassNames}>{formatPrice(item.msrp)}</div>
                <div className={dNetClassNames}>
                  {formatPrice(item.dNetPrice)}
                </div>
              </div>
            );
          })}
        {isAmiUserGlobalAdministrator() && appConfig.isManagementApp && onAddOverrideDiscount && (!quoteCustomLineItem.userDefinedDiscount || quoteCustomLineItem.userDefinedDiscount === null) &&
          <div className="row">
            <div className="col-6">
              <button
                className="btn btn-link p-0"
                type="button"
                onClick={() => onAddOverrideDiscount(quoteCustomLineItem.id)}
              >
                add override discount
              </button>
            </div>
          </div>
        }
        <div className="row unit-price">
          <div className="col-6">Unit Price</div>
          <div className={msrpClassNames}>{formatPrice(pricing.unitMsrp)}</div>
          <div className={dNetClassNames}>{formatPrice(pricing.unitPrice)}</div>
        </div>
        <div className="row mt-1 mb-1">
          <div className="col-3">
            Quantity{' '}
          </div>
          <div className="col-3 text-center">
            {quoteCustomLineItem.quantity}&nbsp;
            {onQuantityUpdated && (
              <button
                className="btn btn-link p-0 m-0 ml-1"
                type="button"
                onClick={() =>
                  this.setState({
                    showQuantityModal: true,
                  })
                }
              >
                <i className="fa fa-edit"></i>
              </button>
            )}
            {onQuantityUpdated && <ReviewQuoteProductQuantityModal
              productName={quoteCustomLineItem.name}
              actualValue={quoteCustomLineItem.quantity}
              onChanged={onQuantityUpdated}
              show={showQuantityModal}
              onHide={this.hideQuantityModal}
            />}
          </div>
        </div>
        <div className="row total-price">
          <div className="col-6">
            Total ({isoCurrencySymbol})
          </div>
          <div className={msrpClassNames}>{formatPrice(pricing.totalMsrp)}</div>
          <div className={dNetClassNames}>{formatPrice(pricing.totalPrice)}</div>
        </div>
      </div>
    );
  }
}
